module.exports = __webpack_public_path__ + "static/media/chair.3068220a.svg";